import { render, staticRenderFns } from "./SpeechToText.vue?vue&type=template&id=0645e65c&scoped=true"
import script from "./SpeechToText.vue?vue&type=script&lang=js"
export * from "./SpeechToText.vue?vue&type=script&lang=js"
import style0 from "./SpeechToText.vue?vue&type=style&index=0&id=0645e65c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0645e65c",
  null
  
)

export default component.exports